import { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ValueOrNull } from "../../../../utils/helpers/tolerance/GeneralHelper";
import { toFixed } from "../../../../utils/helpers/NumberHelper";
import { HelpOutput } from "../../../../components/Inputs/HelpDisplay/HelpOutput";
import ResultBox from "../../../../components/Styled/Box/ResultBox";

const SpecificDisbalanceDisplayer = ({
  specificResidualDisbalance,
  isDisabled,
}) => {
  const { t } = useTranslation();

  const roundedSpecificResidualDisbalance = useMemo(
    () => ValueOrNull(toFixed(specificResidualDisbalance)),
    [specificResidualDisbalance]
  );

  return (
    !isDisabled && (
      <>
        <Typography variant="h4" sx={{ my: 3 }}>
          {t("pages.generalTolerance.results.main")}
        </Typography>
        <ResultBox>
          <Typography variant="h6">
            {t(
              "shared.disbalance.components.residualDisbalanceDisplayer.components.specificDisbalance.title"
            )}
          </Typography>
          <Box sx={{ my: 2, width: "calc(100%)", paddingRight: 2 }}>
            <HelpOutput
              label={
                <div>
                  e<sub>per</sub>, {t("units.length.mkm")}
                </div>
              }
              endAdornment={t("units.length.mkm")}
              helpButtonText={t(
                "shared.disbalance.components.residualDisbalanceDisplayer.components.specificDisbalance.helpButtonText"
              )}
            >
              {roundedSpecificResidualDisbalance}
            </HelpOutput>
          </Box>
        </ResultBox>
      </>
    )
  );
};

export default SpecificDisbalanceDisplayer;
